import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import EmpSuccess from "../employees/employeeSuccess";
import {
  createNewCustomer,
  getAllCustomers,
  updateCustomersById,
} from "../../../apis/customers";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { uploadFile } from "../../../apis/auth";
import CommonSearch from "../commonSearch";
import { Moment } from "moment";
import FileUploader from "./fileUploader";
import { getAllNationalsRetailer } from "../../../apis/nationals";
import Select from "react-select";
import { formatDate } from "../../../environment";
import { assignCustomerToGroup, getAllGroups } from "../../../apis/groups";

const CustomersList = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const groupId = queryParams.get("group_id");
  const groupName = queryParams.get("group_name") || "Group";
  const initialValues = {
    full_name: "",
    email: "",
    fatherName: "",
    gender: "",
    martialStatus: "",
    phone_number: "",
    phone_number2: "",
    aadharNumber: "",
    PanNumber: "",
    company: "",
    dob: "",
    postal_code: "",
    street: "",
    geo_location: "",
  };
  const addressState = {
    addressLine: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
  };
  const permanentaddressState = {
    addressLine1: "",
    city1: "",
    state1: "",
    country1: "",
    pincode1: "",
  };

  const [address, setAddress] = useState(addressState);
  const { city, state, country, pincode, addressLine } = address;
  const [permanentaddress, setPermanentAddress] = useState(
    permanentaddressState
  );
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [formData, setFormData] = useState(initialValues);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<any>();
  const [martialStatus, setMartialStatus] = useState<any>();
  const [emplyomentType, setEmplyomentType] = useState<any>();
  const [customerId, setCustomerId] = useState();
  const [customerDetails, setCustomerDetails] =
    useState<CustomerDetails | null>(null);
  const [newEdit, setNewEdit] = useState(false);
  const [departFin, setDepartFin] = useState<any>([]);
  const [selectedNatOption, setSelectedNatOption] = useState<any>();
  const [finSelectedOption, setFinSelectedOption] = useState<any>();
  const [groupCustomer, setGroupCustomer] = useState<any>();
  const [groupOptions, setGroupOptions] = useState<any[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<any>();
  const [savingGroup, setSavingGroup] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const customerInformation = JSON.parse(sessionStorage.getItem("info"));
  const { city1, state1, country1, pincode1, addressLine1 } = permanentaddress;
  const [selectCheck, setSelectCheck] = useState<boolean>(false);
  useEffect(() => {
    if (selectCheck) {
      setPermanentAddress({
        addressLine1: address?.addressLine,
        city1: address?.city,
        state1: address?.state,
        country1: address?.country,
        pincode1: address?.pincode,
      });
    } else {
      setPermanentAddress({
        addressLine1: "",
        city1: "",
        state1: "",
        country1: "",
        pincode1: "",
      });
    }
  }, [selectCheck]);

  type CustomerForm = {
    full_name: string;
    email: string;
    phoneNumber1: string;
    phoneNumber2: string;
    dob: string;
    fatherName: string;
    gender: string;
    martialStatus: string;
    address: Record<string, string>;
    current_address: Record<string, string>;
    aadharNumber: string;
    PanNumber: string;
    bankName: string;
    bankAccountNo: string;
    ifscCode: string;
    creditScore: number;
    income: number;
    monthlyExpenses: number;
    occupation: string;
    empStartDate: string;
    guarantor: Record<string, string>;
    grandFatherName: string;
    imei1: string;
  };

  const [editData, setEditData] = useState<CustomerForm>({
    full_name: "",
    email: "",
    phoneNumber1: "",
    phoneNumber2: "",
    dob: "",
    fatherName: "",
    gender: "",
    martialStatus: "",
    address: {},
    current_address: {},
    aadharNumber: "",
    PanNumber: "",
    bankName: "",
    bankAccountNo: "",
    ifscCode: "",
    creditScore: 0,
    income: 0.0,
    monthlyExpenses: 0.0,
    occupation: "null",
    empStartDate: "",
    guarantor: {},
    grandFatherName: "",
    imei1: "",
  });

  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleJSONValueChange = (
    field: "address" | "current_address",
    key: string,
    value: string
  ) => {
    setEditData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field], // keep existing keys
        [key]: value, // update only the changed key's value
      },
    }));
  };

  const fixedGuarantorFields = [
    "guarantor_name",
    "guarantor_email",
    "guarantor_number",
    "guarantor_address_proof",
  ];

  const [states, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = states;

  const {
    full_name,
    fatherName,
    email,
    phone_number,
    phone_number2,
    PanNumber,
    aadharNumber,
    dob,
  } = formData;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };
  const handleMartialSelect = (option: any | null) => {
    setMartialStatus(option || undefined);
  };
  const handleEmpSelect = (option: any | null) => {
    setEmplyomentType(option || undefined);
  };
  const Gender = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];
  const employment = [
    { value: "salaried", label: "Salaried" },
    { value: "self-employed", label: "Self-employed" },
    { value: "unemployed", label: "Unemployed" },
  ];
  const martial = [
    { value: "single", label: "Single" },
    { value: "married", label: "Married" },
    { value: "widowed", label: "Widowed" },
    { value: "divorced", label: "Divorced" },
  ];

  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };
  const handlePermaAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPermanentAddress({ ...permanentaddress, [name]: value });
  };
  type EmployeeResponse = {
    group_id?: number;
    group?: any;
    loanAccountNumber: string;
    retailer: any;
    aadharNumber: any;
    full_name: string;
    passportSizePhoto: string;
    geo_location: string;
    Image: string;
    CurrentRole: string;
    email: string;
    phoneNumber1: string;
    Designation: string;
    createdAt: string;
    Status: string;
    id: any;
    address: any;
    current_address: any;
  };

  type EmployeeData = {
    group: any;
    retailer: any;
    aadharNumber: string;
    paySlipImageUrl: unknown;
    key: number;
    EmpId: string;
    Name: string;
    Image: string;
    CurrentRole: string;
    Email: string;
    Phone: string;
    Designation: string;
    JoiningDate: string;
    Status: string;
    id: any;
    allData: any;
    customerAccountNumber: string;
  };
  const fetchAllEmployees = async () => {
    try {
      const data = {
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
        user_id: customerInformation.id,
        user_type: customerInformation.type,
      };
      const response = await getAllCustomers(data);
      const customerRecords = (response?.data || []).filter(
        (customer: EmployeeResponse) => !groupId || Number(customer.group_id) === Number(groupId)
      );
      const employeeData = customerRecords.sort((a: EmployeeResponse, b: EmployeeResponse) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      )
        ?.map(
          (item: EmployeeResponse, i: number) => ({
            key: `${i + 1}`,
            EmpId: `${i + 1}`,
            Name: `${item.full_name}`,
            Image: item.passportSizePhoto ? item.passportSizePhoto : "dummy",
            Email: item.email || "Not Assigned",
            address: (() => {
              try {
                const parsed = JSON.parse(item.address);
                return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                  }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
              } catch {
                return "--";
              }
            })(),
            Phone: item.phoneNumber1 || "Not Assigned",
            CreatedAt: formatDate(item.createdAt),
            // Status: item.Status || "Not Assigned",
            id: item.id || "Not Assigned",
            aadharNumber: item.aadharNumber,
            retailer: item.retailer,
            group: item.group,
            allData: item,
            customerAccountNumber: item.loanAccountNumber,
          })
        );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const loadGroups = async () => {
    setLoadingGroups(true);
    try {
      const response = await getAllGroups({
        user_id: customerInformation?.id,
        vendor_id: customerInformation?.vendor_id,
        user_type: customerInformation?.type,
      });
      setGroupOptions((response?.data || []).map((group: any) => ({
        label: `${group.groupName} (${group.groupCode})`,
        value: group.id,
      })));
    } catch (error) {
      setGroupOptions([]);
      errorAlert("Unable to load groups", "Create a group before assigning customers.");
    } finally {
      setLoadingGroups(false);
    }
  };

  const openGroupModal = async (customer: any) => {
    setGroupCustomer(customer);
    setSelectedGroup(undefined);
    await loadGroups();
  };

  const saveCustomerGroup = async () => {
    if (!groupCustomer || !selectedGroup) {
      errorAlert("Select a group", "Choose a group for this customer.");
      return;
    }

    setSavingGroup(true);
    try {
      const response = await assignCustomerToGroup(selectedGroup.value, groupCustomer.id, {
        user_id: customerInformation?.id,
        vendor_id: customerInformation?.vendor_id,
        user_type: customerInformation?.type,
      });
      if (response.status) {
        successAlert("Success", "Customer added to group successfully.");
        fetchAllEmployees();
      }
    } catch (error: any) {
      errorAlert("Unable to add customer", error?.response?.data?.message || "Please try again.");
    } finally {
      setSavingGroup(false);
    }
  };

  useEffect(() => {
    fetchAllEmployees();
  }, [states, groupId]);

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.EmpId.localeCompare(b.EmpId),
    },
    {
      title: "Created Date",
      dataIndex: "CreatedAt",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        new Date(a.JoiningDate).getTime() - new Date(b.JoiningDate).getTime(),
    },
    {
      title: "Customer Account Number",
      dataIndex: "customerAccountNumber",
      render: (text: string) => <p className="text-dark mb-0">{text}</p>,
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md">
            <img
              src={`${record.Image}`}
              className="img-fluid rounded-circle"
              alt="Employee"
            />
          </div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Aadhar Number",
      dataIndex: "Phone",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{record?.aadharNumber}</p>
        </div>
      ),
    },
    {
      title: "Group Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">{record?.group?.groupName || "--"}</p>
        </div>
      ),
    },
    {
      title: "Branch Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            {record?.retailer?.company_name || record?.retailer?.full_name || "--"}
          </p>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="d-inline-flex">
          <div className="action-icon d-inline-flex">
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleNewEdit(record.allData)}
              className="me-2"
              data-bs-toggle="modal"
              data-bs-target="#edit_employee"
            >
              <i className="ti ti-edit" />
            </div>
          </div>
          <Link
            to={`/customer-view?id=${record?.id}`}
            className="btn btn-primary d-flex align-items-center"
          >
            {"loans"}
          </Link>
          <div
            onClick={() => handleEdit(record)}
            data-bs-toggle="modal"
            data-bs-target="#open_file_uploader"
            className="btn btn-primary d-flex align-items-center ms-2"
          >
            {"Upload Documents"}
          </div>
          <Link
            to={`/emis-records?aadhar=${encodeURIComponent(record.aadharNumber || "")}`}
            className="btn btn-outline-primary d-flex align-items-center ms-2"
          >
            EMI Records
          </Link>
          {!groupId && (
            <button
              type="button"
              onClick={() => openGroupModal(record.allData)}
              data-bs-toggle="modal"
              data-bs-target="#assign_customer_group"
              className="btn btn-outline-primary d-flex align-items-center ms-2"
            >
              Add to Group
            </button>
          )}
        </div>
      ),
    },
  ];

  interface CustomerDetails {
    full_name: string;
    phoneNumber1: string;
    phoneNumber2: string;
    email: string;
    fatherName: string;
    dob: string;
    gender: string;
    martialStatus: number;
    aadharNumber: string;
    PanNumber: string;
    bankName: string;
    bankAccountNo: string;
    ifscCode: string;
    creditScore: number;
    income: number;
    monthlyExpenses: number;
    occupation: string;
    empStartDate: string;
    address: any;
    current_address: any;
    guarantor: any;
    loanAccountNumber: any;
    grandFatherName: any;
    imei1: any;

    // Add other properties as needed
  }

  const handleEdit = (record: any) => {
    setCustomerId(record.id);
  };

  const handleNewEdit = (record: any) => {
    setCustomerId(record.id);
    setCustomerDetails(record);
    setNewEdit(true);

    // Parse address fields if they are strings
    const parsedAddress =
      typeof record.address === "string"
        ? JSON.parse(record.address)
        : record.address || {};

    const parsedCurrentAddress =
      typeof record.current_address === "string"
        ? JSON.parse(record.current_address)
        : record.current_address || {};

    setEditData({
      full_name: record.full_name || "",
      phoneNumber1: record.phoneNumber1 || "",
      phoneNumber2: record.phoneNumber2 || "",
      email: record.email || "",
      fatherName: record.fatherName || "",
      dob: record.dob || "",
      gender: record.gender || "",
      martialStatus: record.martialStatus?.toString() || "",
      address: parsedAddress,
      current_address: parsedCurrentAddress,
      aadharNumber: record.aadharNumber || "",
      PanNumber: record.PanNumber || "",
      bankName: record.bankName || "",
      bankAccountNo: record.bankAccountNo || "",
      ifscCode: record.ifscCode || "",
      creditScore: record.creditScore || 0,
      income: record.income || 0.0,
      monthlyExpenses: record.monthlyExpenses || 0.0,
      occupation: record.occupation || "",
      empStartDate: record.empStartDate || "",
      guarantor: record.guarantor || {},
      grandFatherName: record.grandFatherName || "",
      imei1: record.imei1 || "",
    });
  };

  // const handleNewEdit = (record: any) => {
  //   setCustomerId(record.id);
  //   setCustomerDetails(record);
  //   setNewEdit(true);
  // };

  const mtIdString = sessionStorage.getItem("info");
  let mtId: { id: string; user_id: string } | null = null;

  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const requiredFields = [
      "email",
      "full_name",
      "fatherName",
      "phone_number",
      "PanNumber",
      "dob",
      "aadharNumber",
    ];

    const emptyFields = requiredFields.filter(
      (field) => !formData[field as keyof typeof formData]?.trim()
    );

    if (emptyFields.length > 0) {
      console.error(
        `The following fields are empty: ${emptyFields.join(", ")}`
      );
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }

    const master_Id = mtId?.user_id || "0";

    const payload = {
      email: formData.email,
      full_name: formData.full_name,
      fatherName: formData.fatherName,
      martialStatus: martialStatus.value,
      gender: selectedOption.value,
      phoneNumber1: formData.phone_number,
      phoneNumber2: formData.phone_number2,
      dob: formData.dob,
      PanNumber: formData.PanNumber,
      aadharNumber: formData.aadharNumber,
      current_address: permanentaddress,
      address: address,
      user_name: "",
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      user_id: master_Id,
      type: "customer",
    };

    try {
      const response = await createNewCustomer(payload);
      if (response.status === true) {
        setSuccessCreation(true);
        successAlert("Success", "Loan Successfully Created");
        setImage(null);
        setFormData(initialValues);
        setAddress(addressState);
        setPermanentAddress(permanentaddressState);
        fetchAllEmployees();
        setSelectCheck(false);
      }
    } catch (error) { }
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Data");
    XLSX.writeFile(workbook, "Customer Data.xlsx");
  };

  const fileKey = {
    paySlipImageUrl: "",
    aadharImageUrl: "",
    panImageUrl: "",
    bankStatementsImageUrl: "",
    passportSizePhoto: "",
    singnatureImageUrl: "",
    billImage: "",
    aadharbackimageurl: "",
    guarantorimageurl: "",
    lockscreenimageurl: "",
  };
  const [fileUrls, setFileUrls] = useState<any>(fileKey);

  const titleData = {
    paySlipImageUrl: fileKey.paySlipImageUrl,
    aadharImageUrl: fileKey.aadharImageUrl,
    panImageUrl: fileKey.panImageUrl,
    bankStatementsImageUrl: fileKey.bankStatementsImageUrl,
    passportSizePhoto: fileKey.passportSizePhoto,
    singnatureImageUrl: fileKey.singnatureImageUrl,
    billImage: fileKey.billImage,
    aadharbackimageurl: fileKey.aadharbackimageurl,
    guarantorimageurl: fileKey.guarantorimageurl,
    lockscreenimageurl: fileKey.lockscreenimageurl,
  };

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    const payload = {
      paySlipImageUrl: fileUrls.payslipimageUrl,
      aadharImageUrl: fileUrls.aadharimageUrl,
      panImageUrl: fileUrls.panimageUrl,
      bankStatementsImageUrl: fileUrls.bankstatementsimageUrl,
      passportSizePhoto: fileUrls.passportsizephotoUrl,
      singnatureImageUrl: fileUrls.singnatureimageUrl,
      billImage: fileUrls.billimageUrl,
      aadharbackimageurl: fileUrls.aadharbackimageurlUrl,
      guarantorimageurl: fileUrls.guarantorimageurlUrl,
      lockscreenimageurl: fileUrls.lockscreenimageurlUrl,
    };
    try {
      const response = await updateCustomersById(customerId, payload);
      if (response.status === true) {
        successAlert("Success", "Customer Details Updated Successfully");
        setFileUrls(fileKey);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      errorAlert(
        "Error",
        (error as any)?.response?.data?.message || "Failed to update customer. Please try again."
      );
    }
  };

  const handleNewEditSubmit = async (e: any) => {
    e.preventDefault();
    const newPayload = {
      ...editData,
      occupation: emplyomentType?.value,
      address:
        typeof editData.address === "string"
          ? JSON.parse(editData.address)
          : editData.address,
      current_address:
        typeof editData.current_address === "string"
          ? JSON.parse(editData.current_address)
          : editData.current_address,
    };
    try {
      const response = await updateCustomersById(customerId, newPayload);
      if (response.status === true) {
        fetchAllEmployees();
        successAlert("success", "successfully updated");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      errorAlert(
        "Error",
        (error as any)?.response?.data?.message || "Failed to update customer. Please try again."
      );
    }
  };

  const departNational = [{ value: "retailer", label: "Branches" }];

  const handleNatSelect = (option: any | null) => {
    setSelectedNatOption(option || undefined);
    setFinSelectedOption(undefined);
    getAllFinancer();
  };
  const getAllFinancer = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsRetailer(data);
    const newResponse = response?.data?.retailerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.company_name,
        };
      })
    );
  };
  const handleFinSelect = (option: any | null) => {
    setFinSelectedOption(option || undefined);
    const newResponse = allEmployeeData.filter((ele, i) => {
      return Number(ele.allData.user_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const parsedAddress =
    typeof editData.address === "string"
      ? JSON.parse(editData.address)
      : editData.address;

  const parsedCurrentAddress =
    typeof editData.current_address === "string"
      ? JSON.parse(editData.current_address)
      : editData.current_address;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h4 className="mb-1">{groupId ? `${groupName} Members` : "Customers"}</h4>
              {groupId && <p className="text-muted mb-0">Customer details and loan actions for this group.</p>}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2 d-flex gap-2">
                <Link to="/emis-records" className="btn btn-outline-primary">EMI Records</Link>
                {groupId && (
                  <Link to={`/customer-creations?group_id=${groupId}`} className="btn btn-primary">
                    Add Member
                  </Link>
                )}
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedNatOption
                        ? selectedNatOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departNational?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNatSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {finSelectedOption
                        ? finSelectedOption.label
                        : "Select User"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departFin.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleFinSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={states} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {filteredData && filteredData.length > 0 && (
                <Table
                  dataSource={filteredData}
                  columns={columns}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Customers</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-2 fs-16" />
                          </div>

                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Full Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="full_name"
                            value={full_name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Phone Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="phone_number"
                            value={phone_number}
                            maxLength={10}
                            minLength={10}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Alternate Phone Number{" "}
                          </label>
                          <input
                            type="number"
                            name="phone_number2"
                            value={phone_number2}
                            maxLength={10}
                            minLength={10}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Date of Birth{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="date"
                            name="dob"
                            value={dob}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Aadhar Number{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="number"
                            name="aadharNumber"
                            value={aadharNumber}
                            onChange={handleChange}
                            minLength={12}
                            maxLength={12}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Pan Number <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="PanNumber"
                            value={PanNumber}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Father Name <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="fatherName"
                            value={fatherName}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Gender</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={Gender}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="--Select--"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label"> Martial Status</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={martial}
                            value={martialStatus}
                            onChange={handleMartialSelect}
                            placeholder="--Select--"
                          />
                        </div>
                      </div>

                      <div className="">
                        <label className="form-label">Permanent Address</label>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address Line <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="addressLine"
                            value={addressLine}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            City <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="city"
                            value={city}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            State <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="state"
                            value={state}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Country <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="country"
                            value={country}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            PinCode <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="pincode"
                            value={pincode}
                            onChange={handleAddressChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div
                        className=" d-flex align-items-baseline"
                        style={{ gap: "20px" }}
                      >
                        <input
                          type="checkbox"
                          onChange={() => setSelectCheck(!selectCheck)}
                        />
                        <label className="form-label">
                          Current Address is same as Permanent Address
                        </label>
                      </div>
                      {!selectCheck && (
                        <>
                          <div className="">
                            <label className="form-label">
                              Current Address
                            </label>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Address Line{" "}
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="addressLine1"
                                value={addressLine1}
                                onChange={handlePermaAddressChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                City <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="city1"
                                value={city1}
                                onChange={handlePermaAddressChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                State <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="state1"
                                value={state1}
                                onChange={handlePermaAddressChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Country <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="country1"
                                value={country1}
                                onChange={handlePermaAddressChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                PinCode <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="pincode1"
                                value={pincode1}
                                onChange={handlePermaAddressChange}
                                className="form-control"
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="edit_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Customer </h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <form onSubmit={handleNewEditSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="full_name"
                      value={editData.full_name}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={editData.email}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone Number 1</label>
                    <input
                      type="text"
                      className="form-control"
                      name="phoneNumber1"
                      value={editData.phoneNumber1}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone Number 2</label>
                    <input
                      type="text"
                      className="form-control"
                      name="phoneNumber2"
                      value={editData.phoneNumber2}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Date of Birth</label>
                    <input
                      type="date"
                      className="form-control"
                      name="dob"
                      value={editData.dob}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Father Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="fatherName"
                      value={editData.fatherName}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Gender</label>
                    <input
                      type="text"
                      className="form-control"
                      name="gender"
                      value={editData.gender}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Martial Status</label>
                    <input
                      type="text"
                      className="form-control"
                      name="martialStatus"
                      value={editData.martialStatus}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label fw-semibold">
                      Permanent Address
                    </label>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Address Line</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedAddress.addressLine || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "address",
                              "addressLine",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedAddress.city || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "address",
                              "city",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedAddress.state || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "address",
                              "state",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedAddress.country || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "address",
                              "country",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Pincode</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedAddress.pincode || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "address",
                              "pincode",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label">Current Address</label>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Address Line</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedCurrentAddress.addressLine1 || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "current_address",
                              "addressLine1",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedCurrentAddress.city1 || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "current_address",
                              "city1",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedCurrentAddress.state1 || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "current_address",
                              "state1",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedCurrentAddress.country1 || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "current_address",
                              "country1",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-2">
                        <label className="form-label">Pincode</label>
                        <input
                          type="text"
                          className="form-control"
                          value={parsedCurrentAddress.pincode1 || ""}
                          onChange={(e) =>
                            handleJSONValueChange(
                              "current_address",
                              "pincode1",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Aadhar Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="aadharNumber"
                      value={editData.aadharNumber}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Pan Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="PanNumber"
                      value={editData.PanNumber}
                      onChange={handleEditChange}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Income</label>
                    <input
                      type="number"
                      className="form-control"
                      name="income"
                      value={editData.income}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Monthly Expenses</label>
                    <input
                      type="number"
                      className="form-control"
                      name="monthlyExpenses"
                      value={editData.monthlyExpenses}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Occupation</label>
                      <Select
                        classNamePrefix="react-select"
                        className="select"
                        options={employment}
                        value={emplyomentType}
                        onChange={handleEmpSelect}
                        placeholder="--Select--"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Employment Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="empStartDate"
                      value={editData.empStartDate}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Grand Father Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="grandFatherName"
                      value={editData.grandFatherName}
                      onChange={handleEditChange}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {customerInformation.type !== "customer" && (
                  <button
                    type="submit"
                    data-bs-dismiss="modal"
                    className="btn btn-success"
                  >
                    Submit
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="assign_customer_group" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Customer to Group</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <p className="text-muted">{groupCustomer?.full_name || "Selected customer"}</p>
              <label className="form-label">Group</label>
              <Select
                classNamePrefix="react-select"
                className="select"
                options={groupOptions}
                value={selectedGroup}
                onChange={(option) => setSelectedGroup(option || undefined)}
                placeholder={groupOptions.length ? "Select group" : "No groups available"}
                isLoading={loadingGroups}
              />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-primary" onClick={saveCustomerGroup} disabled={savingGroup || !selectedGroup}>
                {savingGroup ? "Saving..." : "Add to Group"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="open_file_uploader">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Upload Customers Documents</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <div className="modal-body pb-0">
                <div className="row">
                  {Object.keys(titleData).map((key, index) => {
                    const title = key
                      .replace(/([A-Z])/g, " $1")
                      .replace("Url", "")
                      .trim()
                      .replace(/^\w/, (c) => c.toUpperCase());
                    return (
                      <div className="col-md-6 mb-3" key={index}>
                        <FileUploader
                          key={index}
                          setImageUrl={setFileUrls}
                          title={title}
                          previewUrl_={
                            allEmployeeData?.find(
                              (item) => item.id === customerId
                            )?.allData?.[key]
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              {(() => {
                const type = JSON.parse(mtIdString)?.type;
                const employee = allEmployeeData?.find(
                  (item) => item.id === customerId
                );
                const existingData = employee?.allData || {};
                const isAnyImageUploaded = Object.keys(titleData).some(
                  (key) => !!existingData?.[key]
                );
                if (type === "financer" || type === "employee" || !isAnyImageUploaded) {
                  return (
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="btn btn-primary"
                      >
                        Submit
                      </button>
                    </div>
                  );
                }
                return null;
              })()}
            </form>
          </div>
        </div>
      </div>
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default CustomersList;
